import { Col, Row } from "react-bootstrap";
import { Button, TextField, DateSelector, POAmountBox } from "../../common";
import { useLanguageContext, useThemeContext } from "../../../context";
import { useEffect, useState } from "react";
import { DEVICE_HEIGHT, isDateDisabled, toSnakeCase } from "../../../constants";
import { useNavigate } from "react-router-dom";
import {
  observeActiveProducts,
  observePurchaseTax,
  observeUnArchiveCompany,
  observeActivePO,
} from "../../../pos-core/database/helpers";
import withObservables from "@nozbe/with-observables";
import { CreateCompanyModal } from "../../common";
import TableHeader from "../TableContainer/TableHeader";
import List from "./List";
import CsvUploadModal from "../CsvUploadModal";

const CreatePurchaseOrderComponent = ({
  allCompanies,
  company,
  setCompany,
  ship,
  setShip,
  reference,
  setReference,
  poDate,
  setPoDate,
  expected,
  setExpected,
  shippingMethod,
  setShippingMethod,
  notememo,
  setNoteMemo,
  notes,
  setNotes,
  itemData,
  setItemData,
  products,
  purchaseTax,
  handleSelect,
  errors,
  setErrors,
  disablFields,
  purchaseOrder,
  setOrderDiscountModal,
  orderLevelDiscount,
  totalItemsCount,
}) => {
  let navigate = useNavigate();

  console.log("PRODUCTS ARE", products);

  const { I18n } = useLanguageContext();
  const { theme } = useThemeContext();
  const [createCompanyModal, setCreateCompanyModal] = useState(false);
  const [filterData, setFilterData] = useState(products);
  const [cvsModal, setCvsModal] = useState(false);

  const onChange = async (label, val) => {
    if (label == I18n.reference) {
      setReference(val);
    } else if (label == I18n.company) {
      if (val.name == I18n.create_company) {
        setCreateCompanyModal((prev) => !prev);
      } else setCompany(val);
    } else if (label == I18n.ship_to) setShip(val);
    else if (label == I18n.purchase_order_date) setPoDate(val);
    else if (label == I18n.expected_on) setExpected(val);
    else if (label == I18n.shipping_method) setShippingMethod(val);
    else if (label == I18n.notes_Memo) setNoteMemo(val);
    else if (label == I18n.notes) setNotes(val);
    else if (label == I18n.search_by_name) {
      label = "po_line";
      if (val?.id) {
        const product_template = await val.product_template.fetch();

        setItemData((prev) => [
          ...prev,
          {
            name: val?.name,
            id: val?.id,
            product: val,
            unit: product_template?.unit,
          },
        ]);
      }
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (updatedErrors[toSnakeCase(label)]) {
        delete updatedErrors[toSnakeCase(label)];
      }

      return updatedErrors;
    });
  };

  const updateListItem = (label, val, id) => {
    if (label === "taxes") {
      val = val;
    } else if (label === "unit") {
      val = val.name;
    } else {
      val = Number(val);
    }

    const updatedItem = itemData?.map((allItem) => {
      if (allItem.id === id) {
        return {
          ...allItem,
          [label]: val,
        };
      }
      return allItem;
    });
    setItemData(updatedItem);

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (updatedErrors?.poLines?.[id]?.[toSnakeCase(label)] === "required") {
        delete updatedErrors?.poLines?.[id]?.[toSnakeCase(label)];
      }

      return updatedErrors;
    });
  };

  const handleDeleteItem = (listId) => {
    const filterItemData = itemData?.filter((item) => item.id !== listId);
    setItemData(filterItemData);
  };
  const handleSave = () => {
    // handleSave;
  };
  useEffect(() => {
    handleFilter();
  }, [itemData]);

  useEffect(() => {
    setFilterData(products);
  }, [products]);

  const handleFilter = () => {
    const filterProducts = products?.filter(
      (prod) => !itemData.some((item) => item.name === prod.name)
    );
    setFilterData(filterProducts);
  };

  const handleCreateCompany = (val) => {
    setCompany(val);
    setCreateCompanyModal(false);
  };

  function handleImport() {
    setCvsModal((x) => !x);
  }

  return (
    <>
      <Row className="justify-content-md-center">
        <Col md={10}>
          <div className="loginFormBox">
            <div className="signupTextBox">
              <h3
                className="fontSize24 fontWeight600 marBot35 marTop0 textCenter"
                style={{ color: theme.text }}
              >
                {I18n.create_purchase_order}
              </h3>
              <h2
                className="optionPara fontSize20 fontWeight400 marBot15"
                style={{ color: theme.text }}
              >
                {I18n.purchase_order_details}
              </h2>
            </div>
            <div className="itemFields">
              <div className="intventoryFormGridTwo">
                <div className="priceSectionInputLeft">
                  <TextField
                    label={I18n.company}
                    placeholder={I18n.company}
                    onChange={onChange}
                    data={[
                      {
                        name: I18n.create_company,
                        color: theme.barclaysBlue,
                      },
                      ...allCompanies,
                    ]}
                    highlighter={true}
                    value={company}
                    error={errors["company"]}
                    inputType="select"
                    type="text"
                    suffix="downIcon2"
                    suffix_fill={theme.white}
                    suffix_width={"24"}
                    suffix_height={"24"}
                    suffix_viewBox={"0 0 18 18"}
                    disabled={disablFields}
                  />
                </div>
                <div className="priceSectionInputRight">
                  <DateSelector
                    label={I18n.purchase_order_date}
                    icon={"addCustomer"}
                    value={poDate}
                    setValue={onChange}
                    error={errors["purchase_order_date"]}
                    disabled={disablFields}
                  />
                </div>
              </div>
              <div className="intventoryFormGridTwo">
                <div className="priceSectionInputLeft">
                  <DateSelector
                    label={I18n.expected_on}
                    icon={"addCustomer"}
                    value={expected}
                    setValue={onChange}
                    error={errors["expected_on"]}
                    disabled={disablFields}
                    disableDate={(date) => isDateDisabled(date, poDate)}
                  />
                </div>
                <div className="priceSectionInputRight">
                  <TextField
                    label={I18n.shipping_method}
                    placeholder={I18n.shipping_method}
                    onChange={onChange}
                    data={[
                      {
                        name: I18n.cash_on_delivery,
                      },
                      {
                        name: I18n.via_Bank_on_delivery,
                      },
                    ]}
                    highlighter={true}
                    value={shippingMethod}
                    error={errors["shipping_method"]}
                    inputType="select"
                    type="text"
                    suffix="downIcon2"
                    suffix_fill={theme.white}
                    suffix_width={"24"}
                    suffix_height={"24"}
                    suffix_viewBox={"0 0 18 18"}
                    disabled={disablFields}
                  />
                </div>
              </div>

              <div className="intventoryFormGridTwo">
                <div className="priceSectionInputLeft">
                  <TextField
                    onChange={onChange}
                    error={errors["reference"]}
                    label={I18n.reference}
                    placeholder={I18n.reference}
                    value={reference}
                    disabled={disablFields}
                  />
                </div>
                <div className="priceSectionInputRight">
                  <TextField
                    label={I18n.ship_to}
                    placeholder={I18n.ship_to}
                    onChange={onChange}
                    highlighter={true}
                    value={ship?.name}
                    inputType="select"
                    type="text"
                    // suffix="downIcon2"
                    // suffix_fill={theme.white}
                    // suffix_width={"24"}
                    // suffix_height={"24"}
                    // suffix_viewBox={"0 0 18 18"}
                    disabled={true}
                  />
                </div>
              </div>

              <TextField
                label={I18n.notes}
                placeholder={I18n.notes}
                onChange={onChange}
                inputType="textarea"
                rows="1"
                value={notes}
                disabled={disablFields}
              />

              <p
                style={{ background: theme.topBarBG }}
                className="itemSeperator"
              ></p>

              <div className="itemDetailHeading justifySpa">
                <p
                  className="fontSize20 fontWeight400 marBot0"
                  style={{ color: theme.text }}
                >
                  {I18n.item_information}
                </p>
                <p
                  className="fontSize14 fontWeight500 marBot0 cursorPointer"
                  onClick={handleImport}
                  style={{ color: theme.barclaysBlue }}
                >
                  {I18n.import_items}
                </p>
              </div>
              <p
                style={{ background: theme.topBarBG }}
                className="itemSeperator itemDetailListSep"
              ></p>

              {/* <TableHeader
                className={`potableColume`}
                style={{ borderColor: theme.posRightBg }}
              >
                <div className="BoxWidth justifyStart">
                  <p
                    className="fontSize16 OneLineTruncate"
                    style={{ color: theme.white }}
                  >
                    {I18n.item}
                  </p>
                </div>
                <div className=" BoxWidth ">
                  <p
                    className="fontSize16 OneLineTruncate"
                    style={{ color: theme.white }}
                  >
                    {I18n.qty}
                  </p>
                </div>
                <div className="BoxWidth ">
                  <p
                    className="fontSize16 OneLineTruncate"
                    style={{ color: theme.white }}
                  >
                    {I18n.u_cost}
                  </p>
                </div>
                <div className="BoxWidth ">
                  <p
                    className="fontSize16 OneLineTruncate"
                    style={{ color: theme.white }}
                  >
                    {I18n.amount_with_rs}
                  </p>
                </div>

                <div className="BoxWidth ">
                  <p
                    className="fontSize16 OneLineTruncate"
                    style={{ color: theme.white }}
                  >
                    {I18n.discount}
                  </p>
                </div>
                <div className="BoxWidth ">
                  <p
                    className="fontSize16 OneLineTruncate"
                    style={{ color: theme.white }}
                  >
                    {I18n.taxes}
                  </p>
                </div>
               
                <div className="BoxWidth ">
                  <p
                    className="fontSize16 OneLineTruncate"
                    style={{ color: theme.white }}
                  >
                    {I18n.amount}
                  </p>
                </div>
              </TableHeader> */}

              {itemData.length
                ? itemData.map((item, index) => {
                    return item.name ? (
                      <div key={item.id}>
                        <List
                          I18n={I18n}
                          theme={theme}
                          item={item}
                          purchaseTax={purchaseTax}
                          updateListItem={updateListItem}
                          handleDeleteItem={handleDeleteItem}
                          setErrors={setErrors}
                          errors={errors}
                          disablFields={disablFields}
                        />
                      </div>
                    ) : null;
                  })
                : null}

              <div className="marTop10">
                <TextField
                  onChange={onChange}
                  setOptionAsLabel={true}
                  label={I18n.search_by_name}
                  placeholder={I18n.search_by_name}
                  value={""}
                  data={[...filterData]}
                  highlighter={true}
                  inputType="select"
                  type="text"
                  suffix="downIcon2"
                  suffix_fill={theme.white}
                  suffix_width={"24"}
                  suffix_height={"24"}
                  suffix_viewBox={"0 0 18 18"}
                  disabled={disablFields}
                  error={errors["po_line"]}
                />
              </div>

              <TextField
                label={I18n.notes_Memo}
                placeholder={I18n.notes_Memo}
                onChange={onChange}
                value={notememo}
                disabled={disablFields}
              />

              <POAmountBox
                itemData={itemData}
                setOrderDiscountModal={setOrderDiscountModal}
                orderLevelDiscount={orderLevelDiscount}
                disable={disablFields}
              />

              <CreateCompanyModal
                setToggle={setCreateCompanyModal}
                toggle={createCompanyModal || true}
                handleCreateCompany={handleCreateCompany}
              />
              <CsvUploadModal
                setToggle={setCvsModal}
                toggle={cvsModal}
                type={"item"}
              />
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

const enhance = withObservables(["totalItemsCount"], ({ totalItemsCount }) => ({
  allCompanies: observeUnArchiveCompany(),
  products: observeActiveProducts(0, totalItemsCount),
  purchaseTax: observePurchaseTax(),
}));

export default enhance(CreatePurchaseOrderComponent);
